function gtag_report_conversion(url) {
  var callback = function () {
    if (typeof(url) != 'undefined') {
      window.location = url;
    }
  };
  gtag('event', 'conversion', {
      'send_to': 'AW-610078224/QuduCOfImcgZEJCc9KIC',
      'event_callback': callback
  });
  return false;
}

function gtag_report_conversion_2(url) {
  var callback = function () {
    if (typeof(url) != 'undefined') {
      window.location = url;
    }
  };
  gtag('event', 'conversion', {
      'send_to': 'AW-16797027039/Vl5hCMzapu8ZEN-Vuck-',
      'event_callback': callback
  });
  return false;
}

$(document).ready(function(){
  // BEGIN code to add country filter
  let paramString = window.location.href.split('?')[1];
  let queryString = new URLSearchParams(paramString);
  let filterCountry = queryString.get('filter.p.m.custom.country');
  if (filterCountry != null){
    $('#filter-country').val(filterCountry);
  }
  // END code to add country filter
})

function isEmail(email) {
  var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(email);
}

function isValidEmail(){
  $('.text-muted').hide();
  let email = $('#cc-popup-mailinglist_email').val();
  if (! isEmail(email)){
    $('#emailHelp').show('shake');
  }
}

function saveCustomerInfo(){
  let name = $('#cc-popup-mailinglist_name').val();
  let phone = $('#cc-popup-mailinglist_phone').val();
  let email = $('#cc-popup-mailinglist_email').val();
  // let country = $('#cc-popup-mailinglist_country').find(":selected").attr('value');
  let country = localStorage.getItem("affiliateName", "Test");
  if (country == null || country === undefined || country == ""){
    country = "Test"
  }
  
  if (! isEmail(email)){
    $('#emailHelp').show('shake');
    return false;
  }
  
  if ( phone=="" || phone== undefined){
    $('#phoneHelp').show('shake');
    return false;
  }

  // else if (!phone.match(/^\d{11}$/)){
  //   $('#phoneHelp').show('shake');
  //   return false;
  // }
    
  else if (!phone.match(/^[6-9]\d{9}$/)){
    $('#phoneHelp').show('shake');
    return false;
  }
  
  if ( name=="" || name== undefined){
    $('#nameHelp').show('shake');
    return false;
  }
  else if(!name.match(/^[A-Za-z ]+$/)){
    $('#nameHelp').show('shake');
    return false;
  }
  
  if ( country=="" || country== undefined){
    alert("Select a valid country");
    return false;
  }
  
  $('#save-customer-submit').prop('disabled', true);
  $('#save-customer-submit').val('Submitting...');
  $('.text-muted').hide();
  
  var settings = {
    "url": "https://azcms.matrix.co.in/shopify/api/matrixindiastore/saveCustomerInfo", //"https://tab.matrix.in/ShopAPI/api/Values/InsertCustomerInfo",
    "method": "POST",
    "headers": {
      "Content-Type": "application/json"
    },
    "data": JSON.stringify({
      "Name": name,
      "Email": email,
      "MobileNo": phone,
      "Country": country,
      "affiliateName": localStorage.getItem("affiliateName", "")
    }),
  };

  $('#myModal').modal('hide');
  
  $.ajax(settings).done(function (response) {
    if (response.success == 1){
      $('#myModal').modal('hide');
      $('.cc-popup-close').click();
      localStorage.setItem("isMatrixPopupFilled", true);
      localStorage.setItem("isThemeMatrixPopupFilled", true);
      $('.float-btn-popup').hide()
    }
    else {
      alert(response.message);
    }
    setTimeout(function() {
      $('#save-customer-submit').prop('disabled', false);
      $('#save-customer-submit').val('Submit');
    }, 1000)
  });
  gtag_report_conversion();
  gtag_report_conversion_2();
}

function isName(evt){
  $('.text-muted').hide();
  if( (evt.keyCode>64 && evt.keyCode<91) || (evt.keyCode == 32) || (evt.keyCode == 190) || (evt.keyCode == 16) || (evt.keyCode == 46) || (evt.keyCode == 8) || (evt.keyCode == 91) || (evt.keyCode == 20) || (evt.keyCode == 27) || (evt.keyCode == 9) || (evt.keyCode === undefined) || (evt.keyCode == 229) ){
    return true;
  }
  else{
    $('#nameHelp').show('shake');
    return false;
  }
}

function isPhone(evt){
  $('.text-muted').hide();
  if( (evt.keyCode>47 && evt.keyCode<58) || (evt.keyCode == 46) || (evt.keyCode == 8) || (evt.keyCode == 16) || (evt.keyCode == 91) || (evt.keyCode == 20) || (evt.keyCode == 27) || (evt.keyCode == 9) || (evt.keyCode === undefined) || (evt.keyCode == 229) ){
    return true;
  }
  else{
    $('#phoneHelp').show('shake');
    return false;
  }
}

function setGetParam(key,value) {
  if (history.pushState) {
    var params = new URLSearchParams(window.location.search);
    params.set(key, value);
    var newUrl = window.location.origin 
          + window.location.pathname 
          + '?' + params.toString();
    window.history.pushState({path:newUrl},'',newUrl);
  }
}

function changeProductCountry(node){
  let country = $(node).find(":selected").attr('value');
  if(country === undefined){
    country = ""
  }
  setGetParam('filter.p.m.custom.country',country);
  window.location.reload();
}

function checkGST(){
  let gstNum = $('#note').val();
  if (gstNum == ""){
  }
  else{
    if (!gstNum.match(/^\d{2}[A-Z]{5}\d{4}[A-Z]{1}\d{1}Z(\w){1}$/)){
      $('#note').addClass("gst-number-error")
      $('#note').focus();
      alert("Enter a valid GST Number");
      return false;
    }
  }
  if ( getCookie('isAirIndiaLoyalty') ){
    let ffNumber = $('#frequentFlyerNo').val();
    if (ffNumber){
      var isvalidateFrequentFlyerNumberValid = validateFrequentFlyerNumber(ffNumber);
      if(!isvalidateFrequentFlyerNumberValid){
        $('#frequentFlyerNo').addClass("frequentFlyerNo-error")
        $('#frequentFlyerNo').focus();
        alert("Enter valid Maharaja Club Id");
        return false;
      }
    }
    
  }
  return checkPhoneNo();
}

var leadApiToken = null;

function getLeadApiToken() {
  $.ajax({
    url: "https://azcms.matrix.co.in/matrixindiastore/api/token",
    method: "GET",
    async: false,
    success: function(data) {
      leadApiToken = data.token;
    },
    error: function() {
      leadApiToken = null;
    }
  });
}

function checkPhoneNo() {
  let phoneNo = $('#phoneNo').val();
  if (localStorage.getItem("isThemeMatrixPopupFilled")) {
    $('#phoneNo').removeAttr('required');
    return true;
  }
  if ($('#phoneNo').attr('required') === undefined) {
    return true;
  }
  if (!phoneNo.match(/\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/)) {
    $('#phoneNo').addClass("gst-number-error");
    $('#phoneNo').focus();
    alert("Enter a valid Mobile Number");
    return false;
  } else {
    $('#update-cart').attr('disabled', 'disabled');

    let country = localStorage.getItem("affiliateName") || "Test";

    // Make sure we have a token
    if (!leadApiToken) {
      getLeadApiToken();
    }

    var settings = {
      "url": "https://azcms.matrix.co.in/matrixindiastore/api/saveCustomerInfo",
      "method": "POST",
      "headers": {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + leadApiToken
      },
      "data": JSON.stringify({
        "Name": "Test",
        "Email": "test@s.com",
        "MobileNo": phoneNo,
        "Country": country,
        "affiliateName": localStorage.getItem("affiliateName") || ""
      }),
      "async": false
    };

    $.ajax(settings).done(function (response) {
      try {
        $('#update-cart').removeAttr('disabled');
        console.log(response.toString());
      } catch (error) {
        console.log(error);
      }
      setTimeout(function() {
        return true;
      }, 1000);
    }).fail(function (xhr) {
      $('#update-cart').removeAttr('disabled');
      // Token may have expired — refresh and retry once
      if (xhr.status === 401) {
        getLeadApiToken();
        $.ajax({
          url: "https://azcms.matrix.co.in/matrixindiastore/api/saveCustomerInfo",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + leadApiToken
          },
          data: settings.data,
          async: false
        });
      } else {
        console.log("Submit failed:", xhr.status, xhr.responseText);
      }
    });
    return true;
  }
}

// BEGIN code to show popup notification in case of modal closure
$(function() {
    $(document).click(function (){
        if (!$('.cc-popup--visible').is(':visible')) {
            if (!localStorage.getItem("isThemeMatrixPopupFilled")) {
              $('.float-btn-popup').show()
            }
        }
    });
});
// END code to show popup notification in case of modal closure

// Function to validate Frequent FLyer Number of Air India
function validateFrequentFlyerNumber(number) {
    // Ensure the input is exactly 9 digits and numeric
    if (!/^\d{9}$/.test(number)) {
        return false;
    }
    // Extract the first 8 digits and the check digit
    const digits = number.slice(0, 8).split("").map(Number);
    const checkDigit = parseInt(number[8], 10);
    // Define weights
    const weights = [8, 7, 6, 5, 4, 3, 2, 1];
    // Calculate the weighted sum with digit-sum logic
    const weightedSum = digits.reduce((sum, digit, index) => {
        const product = digit * weights[index];
        const productDigitSum = product >= 10 ? Math.floor(product / 10) + (product % 10) : product;
        return sum + productDigitSum;
    }, 0);
    // Compute MOD7
    const mod7 = weightedSum % 7;
    // Check if MOD7 matches the ninth digit
    return mod7 === checkDigit;
}

// Getting a Cookie by Name
function getCookie(name) {
    // Get all cookies as a single string
    const cookieString = document.cookie;
    // Split the cookie string into individual cookies
    const cookies = cookieString.split(';');
    // Loop through each cookie
    for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i].trim(); // Trim any leading/trailing whitespace
        // If the cookie starts with the desired name, return the value
        if (cookie.startsWith(name + "=")) {
            return cookie.substring(name.length + 1); // Return the value after the '='
        }
    }
    // Return null if the cookie is not found
    return null;
}

function validateNumberInputOnly(input) {
    // Remove 'e', '-', and '+' characters
    input.value = input.value.replace(/[eE\-+]/g, '');
    // Limit to 9 characters
    if (input.value.length > 9) {
        input.value = input.value.slice(0, 9);
    }
}